import { LoadingOutlined } from '@ant-design/icons';

function Loader() {
  return (
    <div className="loader">
      <LoadingOutlined />
    </div>
  );
}

export default Loader;
